import { Checkbox, TextField } from '@fluentui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const Connection = (props) => {

    const [t] = useTranslation();

  return (
    <>
    {!props.success && (
        <div style={{ padding:"18px", height: props.isRadiologistModalOpen ? "140px" : "110px", display: "flex", alignItems: "center"}}>
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    <TextField
                        className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12" 
                        name="code"
                        placeholder={t("hospital.enter-code")}
                        onChange={(value, data) => {
                            console.log(data);
                            props.setCode(data);
                            props.setErrorMsg("");
                        }}
                        value={props.code}
                        errorMessage={props.errorMsg}
                        label={props.label}
                        required
                    />
                </div>
                <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                    {props.isRadiologistModalOpen ? (
                      <Checkbox
                        className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12" 
                        value={props.onPayroll}
                        label="On Payroll"
                        onChange={(e, check) => props.setOnPayroll(check)}
                        boxSide="start"
                      />
                  ) : (
                    <></>
                  )}
                </div>
            </div>
        </div>
      )}
      {props.success && (
        <div style={{height: "70px", display: "flex", alignItems: "center"}}>
          <p style={{ marginLeft: "10px" }}>{props.successMsg}</p>
        </div>
      )}
      </>
  )
}

export default Connection